import { FC } from 'react';

import { Paper, Typography } from '@mui/material';

import { PurchaseOrderLookup } from '../model';
import { getReceivingStatus } from '../receivingStatus';

interface ReceivingStatusBannerProps {
  purchaseOrder: PurchaseOrderLookup;
}

const ReceivingStatusBanner: FC<ReceivingStatusBannerProps> = ({ purchaseOrder }) => {
  const status = getReceivingStatus(purchaseOrder);

  return (
    <>
      <Paper style={{ padding: 16, backgroundColor: status.color }}>
        <Typography variant="h5" fontWeight="bold" style={{ color: '#fff' }}>
          {purchaseOrder.vendor_name || '—'}
        </Typography>
        <Typography variant="h6" style={{ color: '#fff' }}>
          {status.text}
        </Typography>
      </Paper>
      {/* Buyer's intended spot — after the first receipt, rack/shelf/bin on the PO are the last put-away (C10). */}
      <Typography variant="body2" color="text.secondary" style={{ marginTop: 8 }}>
        {purchaseOrder.assigned_location}
      </Typography>
    </>
  );
};

export default ReceivingStatusBanner;
